import { render, staticRenderFns } from "./requisitos.vue?vue&type=template&id=73d2c6b2&scoped=true"
import script from "./requisitos.vue?vue&type=script&lang=js"
export * from "./requisitos.vue?vue&type=script&lang=js"
import style0 from "./requisitos.vue?vue&type=style&index=0&id=73d2c6b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d2c6b2",
  null
  
)

export default component.exports